import * as React from 'react';
import { Table } from 'antd';
import * as ReactDOM from 'react-dom';
import { elementOuterHeight } from 'src/utils/utils';
import injectSheet from 'react-jss';
import { defaultSorter } from '../../../utils/utils';
import Chartify from  '@shipsy/chartify';

const styles = theme => ({
  tableMain: {
    '& .ant-table-thead > tr > th.ant-table-column-has-filters .ant-table-column-sorters': {
      paddingRight: '34px',
    },
    '& .ant-table-thead > tr > th .ant-table-column-sorters': {
      paddingRight: '8px',
    },
  },
});

class TableViz extends React.PureComponent<any, any> {

  state: any = {
    filteredInfo: null,
    sortedInfo: null,
    scrollY: 0,
  };

  tableRef;

  constructor(props) {
    super(props);
    this.tableRef = React.createRef();
  }

  getFilterData = (column) => {
    const { chartData } = this.props;
    const visited = {};
    const filterKeys = chartData.content.map((rowData:any) => {
      if (visited[rowData[column]]) {
        return null ;
      }
      visited[rowData[column]] = true;

      return {
        value: rowData[column],
        text: rowData[column],
      };
    });
    return filterKeys.filter(value => value);

  }

  getScrollHeight = () => {
    const { height, width } = this.props;
    const tableElement: any = ReactDOM
      .findDOMNode(this.tableRef.current);

    if (!tableElement || !height || !width) {
      return 0;
    }
    const tableHeaderElementHeight = tableElement
      .getElementsByTagName('thead')[0]
      .offsetHeight ;

    const paginationElement = tableElement
      .getElementsByClassName('ant-table-pagination')[0];
    // Pagination might not always be present
    const paginationElementHeight = paginationElement ? elementOuterHeight(paginationElement) : 0;

    // Offset of position of title (equal to 1 (top: 1 in ant css))
    const titlePositionOffset = 1;

    const tableTitleElementHeight = tableElement
    .getElementsByClassName('ant-table-title')[0] ?
      tableElement
        .getElementsByClassName('ant-table-title')[0]
        .offsetHeight + titlePositionOffset : 0;

    const cardHeaderHeight =
      (tableHeaderElementHeight
        + tableTitleElementHeight
        + paginationElementHeight
      );
    return Math.max(0, (height - cardHeaderHeight));
  }

  getWidthOfColumns = (totalWidth, numberOfColumns) => {
    const minWidth = 120;
    const w1 = Math.floor((totalWidth - 1) / numberOfColumns);
    if (w1 < minWidth) {
      return minWidth;
    }
    return w1;
  }

  componentDidMount () {
    const scrollY = this.getScrollHeight();
    if (scrollY !== this.state.scrollY) {
      this.setState({ scrollY });
    }
  }

  componentDidUpdate () {
    const scrollY = this.getScrollHeight();
    if (scrollY !== this.state.scrollY) {
      this.setState({ scrollY });
    }
  }

  handleChange = (pagination, filters, sorter) => {
    this.setState({
      filteredInfo: filters,
      sortedInfo: sorter,
    });
    const { onPaginateChange } = this.props;
    if (onPaginateChange) {
      onPaginateChange(pagination);
    }
  }

  render() {
    const { chartData, width, height, classes, formData, pageSize, customHeader } = this.props;
    const chartifyInstance = new Chartify.TableData(chartData, formData);
    const chartifyData = chartifyInstance.getManipulatedChartDataAndOptions();
    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};
    const dataSource = chartifyData.data;
    let columns: any = (chartData && chartData.content && chartData.content.length) ?
    Object.keys(chartData.content[0]) : [];
    columns = columns.filter(column => column !== 'key');
    const columnWidth = this.getWidthOfColumns(width, columns.length);
    columns = columns.map((column:any) => {
      const tableColumn: any = {
        title: column,
        key: column,
        dataIndex: column,
        // width: Math.floor((width - 1) / columns.length),
        width: columnWidth,
      };
      if (chartData
        && chartData.content
        && chartData.content.length
        && (typeof chartData.content[0][column] === 'string')) {
        tableColumn.filters = this.getFilterData(column);
        tableColumn.filteredValue = filteredInfo[column] || null;
        tableColumn.onFilter = (value, record) => record[column].includes(value);
        tableColumn.sorter = (a, b) => defaultSorter(a[column], b[column]);
        tableColumn.sortOrder = sortedInfo.columnKey === column && sortedInfo.order;
      } else if (typeof chartData.content[0][column] !== 'string') {
        tableColumn.sortOrder = sortedInfo.columnKey === column && sortedInfo.order;
        tableColumn.sorter = (a, b) => defaultSorter(a[column], b[column]);
      }
      return tableColumn;
    });
    return (
    <div style={{ overflowX: 'auto', width: '100%' }}>
    <Table bordered
      ref={this.tableRef}
      columns={columns}
      dataSource={dataSource}
      onChange={this.handleChange}
      title={chartData.header ?
          () => (<div>
           <span>Total Count: </span>
           <span>{chartData.content.length}</span>
         </div>) : undefined}
      pagination={{
        simple: true,
        hideOnSinglePage: true,
        position: 'top',
        pageSize: pageSize ? pageSize : 20 }}
      scroll={{
        y: (width && height) ? this.state.scrollY : false,
        x: columnWidth * columns.length,
      }}
      className={classes.tableMain}
      size="middle"
    ></Table>
    </div>);
  }

}
export default injectSheet(styles)(TableViz);
